import { render, staticRenderFns } from "./addOwner.vue?vue&type=template&id=682ed6cc&scoped=true&"
import script from "./addOwner.vue?vue&type=script&lang=js&"
export * from "./addOwner.vue?vue&type=script&lang=js&"
import style0 from "./addOwner.vue?vue&type=style&index=0&id=682ed6cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ed6cc",
  null
  
)

export default component.exports